import {
  PortingAuditField,
  PortingAuditFieldType,
  PortingAuditHistoryRecord,
} from '../../../apis/porting/porting.types';

export const CountryCodes = {
  USA: { Code: 'US', Label: 'USA' },
  Canada: { Code: 'CA', Label: 'Canada' },
};

export const PortingAuditFieldLabelMap: Record<PortingAuditField, string> = {
  [PortingAuditField.PORTING_AUDIT_FIELD_UNKNOWN]: 'Unknown',
  [PortingAuditField.PORTING_AUDIT_FIELD_ACCOUNT_PIN]: 'Account PIN',
  [PortingAuditField.PORTING_AUDIT_FIELD_AUTHORISED_USER_FIRST_NAME]: 'First Name',
  [PortingAuditField.PORTING_AUDIT_FIELD_AUTHORISED_USER_LAST_NAME]: 'Last Name',
  [PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_HOUSE_NUMBER]: 'House Number',
  [PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_STREET1]: 'Street 1',
  [PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_STREET2]: 'Street 2',
  [PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_CITY]: 'City',
  [PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_STATE]: 'State',
  [PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_COUNTRY]: 'Country',
  [PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_ZIP]: 'Pincode',
  [PortingAuditField.PORTING_AUDIT_FIELD_COMPANY_NAME]: 'Company Name',
  [PortingAuditField.PORTING_AUDIT_FIELD_CURRENT_PHONE_SERVICE_PROVIDER]:
    'Current Phone Provider',
  [PortingAuditField.PORTING_AUDIT_FIELD_PHONE_SERVICE_ACCOUNT_NUMBER]: 'Account Number',
  [PortingAuditField.PORTING_AUDIT_FIELD_REQUESTED_FIRM_ORDER_COMMITMENT_DATE]:
    'Requested Port Date',
  [PortingAuditField.PORTING_AUDIT_FIELD_BILLING_PHONE_NUMBER]: 'Billing Phone Number',
  [PortingAuditField.PORTING_AUDIT_FIELD_OFFICE_EMAIL]: 'Office Email',
  [PortingAuditField.PORTING_AUDIT_FIELD_PROVIDER]: 'Provider',
  [PortingAuditField.PORTING_AUDIT_FIELD_PHONE_NUMBERS]: 'Phone Numbers',
  [PortingAuditField.PORTING_AUDIT_FIELD_FAX_NUMBERS]: 'Fax Numbers',
  [PortingAuditField.PORTING_AUDIT_FIELD_SMS_NUMBERS]: 'SMS Numbers',
};

export const PortingAuditRecordKeyDataMap: Record<
  keyof PortingAuditHistoryRecord,
  { label: string; type?: PortingAuditFieldType; isPrivate?: boolean }
> = {
  id: {
    label: 'Revision ID',
    isPrivate: true,
  },
  portingDataId: {
    label: 'Porting ID',
    isPrivate: true,
  },
  changesInitiatedAt: {
    label: 'Changed At',
    isPrivate: true,
  },
  changesInitiatedBy: {
    label: 'Changed By',
    isPrivate: true,
  },
  authorisedUserFirstName: {
    label:
      PortingAuditFieldLabelMap[
        PortingAuditField.PORTING_AUDIT_FIELD_AUTHORISED_USER_FIRST_NAME
      ],
  },
  authorisedUserLastName: {
    label:
      PortingAuditFieldLabelMap[
        PortingAuditField.PORTING_AUDIT_FIELD_AUTHORISED_USER_LAST_NAME
      ],
  },
  serviceHouseNumber: {
    label:
      PortingAuditFieldLabelMap[
        PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_HOUSE_NUMBER
      ],
  },
  serviceStreet1: {
    label:
      PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_STREET1],
  },
  serviceStreet2: {
    label:
      PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_STREET2],
  },
  serviceCity: {
    label: PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_CITY],
  },
  serviceState: {
    label: PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_STATE],
  },
  serviceCountry: {
    label:
      PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_COUNTRY],
  },
  serviceZip: {
    label: PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_SERVICE_ZIP],
  },
  companyName: {
    label: PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_COMPANY_NAME],
  },
  currentPhoneServiceProvider: {
    label:
      PortingAuditFieldLabelMap[
        PortingAuditField.PORTING_AUDIT_FIELD_CURRENT_PHONE_SERVICE_PROVIDER
      ],
  },
  phoneServiceAccountNumber: {
    label:
      PortingAuditFieldLabelMap[
        PortingAuditField.PORTING_AUDIT_FIELD_PHONE_SERVICE_ACCOUNT_NUMBER
      ],
  },
  requestedFirmOrderCommitmentDate: {
    label:
      PortingAuditFieldLabelMap[
        PortingAuditField.PORTING_AUDIT_FIELD_REQUESTED_FIRM_ORDER_COMMITMENT_DATE
      ],
    type: 'date',
  },
  billingPhoneNumber: {
    label:
      PortingAuditFieldLabelMap[
        PortingAuditField.PORTING_AUDIT_FIELD_BILLING_PHONE_NUMBER
      ],
    type: 'phone',
  },
  accountPin: {
    label: PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_ACCOUNT_PIN],
  },
  officeEmail: {
    label: PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_OFFICE_EMAIL],
    type: 'email',
  },
  provider: {
    label: PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_PROVIDER],
  },
  phoneNumbers: {
    label: PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_PHONE_NUMBERS],
    type: 'phone',
  },
  faxNumbers: {
    label: PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_FAX_NUMBERS],
    type: 'phone',
  },
  smsNumbers: {
    label: PortingAuditFieldLabelMap[PortingAuditField.PORTING_AUDIT_FIELD_SMS_NUMBERS],
    type: 'phone',
  },
};
